import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileCheck2, Sparkles, Download } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const IntakeReceivedCard = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/referto/intake-returns").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items || items.length === 0) return null;
  const open = (it) => {
    const p = new URLSearchParams({ intake: it.id });
    if ((it.patient_fiscal_code || "").length === 16) p.set("cf", it.patient_fiscal_code);
    navigate(`/nuovo-referto?${p.toString()}`);
  };
  return (
    <Card className="mt-4 md:mt-6 p-3 md:p-5 rounded-xl border-emerald-200 shadow-sm bg-white" data-testid="dashboard-intake-received">
      <div className="flex items-center gap-2 mb-3">
        <div className="h-9 w-9 rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-200 flex items-center justify-center"><FileCheck2 className="h-5 w-5" /></div>
        <div>
          <h3 className="font-heading text-base md:text-lg font-bold text-slate-900">Moduli ricevuti</h3>
          <p className="text-xs text-slate-500">{items.length} modul{items.length === 1 ? "o" : "i"} di accoglienza riconsegnat{items.length === 1 ? "o" : "i"} da importare</p>
        </div>
      </div>
      <ul className="divide-y divide-slate-100">
        {items.map((it) => (
          <li key={it.id} className="py-2.5 flex items-center gap-3 flex-wrap" data-testid={`intake-received-${it.id}`}>
            <div className="flex-1 min-w-[220px]">
              <div className="font-semibold text-slate-900 text-sm">{it.first_name} {it.last_name}
                <span className="ml-2 text-xs font-normal text-slate-500">{it.patient_fiscal_code}</span></div>
              <div className="mt-1 flex items-center gap-1.5 text-[11px]">
                <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 border bg-emerald-100 text-emerald-800 border-emerald-200" data-testid={`intake-received-badge-${it.id}`}>
                  <FileCheck2 className="h-3 w-3" /> Modulo ricevuto · {new Date(it.returned_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                </span>
                {it.visit_date && <span className="text-slate-500">visita {new Date(it.visit_date).toLocaleDateString("it-IT")}</span>}
              </div>
            </div>
            <div className="flex items-center gap-1.5 flex-wrap">
              {(it.files || []).map((f) => (
                <a key={f.idx} href={`${API_BASE}/api/referto/intake-returns/${it.id}/file/${f.idx}`} target="_blank" rel="noreferrer"
                   data-testid={`intake-download-${it.id}-${f.idx}`}
                   className="inline-flex items-center h-8 px-2.5 rounded-md border border-slate-300 bg-white text-xs text-slate-700 hover:bg-slate-50">
                  <Download className="h-3.5 w-3.5 mr-1" /> {it.files.length > 1 ? `File ${f.idx + 1}` : "Scarica modulo"}
                </a>
              ))}
              <Button size="sm" onClick={() => open(it)} data-testid={`intake-import-${it.id}`}
                      className="h-8 text-xs bg-[#1E88E5] hover:bg-[#1976D2] text-white">
                <Sparkles className="h-3.5 w-3.5 mr-1" /> Importa con AI
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};
